

/**
 * @name DeclineAssociationController
 * @description Function to handle association declines
 * @param {service} $uibModalInstance UI Bootstrap image modal instance
 * @param {service} Association The association service
 * @param {object} association Resolved association from the component controller
 */
function DeclineAssociationController(
  $uibModalInstance,
  Association,
  association // From the resolve
) {
  let vm = this;
  vm.association = association;
  vm.decline = decline;

  /**
   * @name decline
   * @description Function to decline an association
   * @param {object} association The association to decline
   */
  function decline(association) {
    Association.declineByUser(association)
    .then(function(updatedAssociation) {
      $uibModalInstance.close(updatedAssociation);
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('DeclineAssociationController', DeclineAssociationController);



// WEBPACK FOOTER //
// ./components/collector/associations/list/decline-association-modal.controller.js